import {Action} from "redux";
import {Project} from "../../domain/model/project";

export enum CustomerTutorialActionType {
    REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST = "CUSTOMER_DASHBOARD_REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST",
    CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST = "CUSTOMER_DASHBOARD_CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST",

}

export interface IRequestGetAllByRecommendProjectListAction extends Action {
    type: CustomerTutorialActionType.REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST;
}

export interface ICallbackGetAllByRecommendProjectListAction extends Action {
    type: CustomerTutorialActionType.CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST;
    isSuccess: boolean;
    item: Project[];
}

export type CustomerTutorialAction =
    IRequestGetAllByRecommendProjectListAction |
    ICallbackGetAllByRecommendProjectListAction ;

export interface ICustomerTutorialActionCreator {
    requestGetAllByRecommendProjectListAction(): IRequestGetAllByRecommendProjectListAction;

    callbackGetAllByRecommendProjectListAction(isSuccess: boolean, item: Project[]): ICallbackGetAllByRecommendProjectListAction;
}

class ActionCreator implements ICustomerTutorialActionCreator {
    public requestGetAllByRecommendProjectListAction = (): IRequestGetAllByRecommendProjectListAction => {
        return {
            type: CustomerTutorialActionType.REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST,
        };
    };

    public callbackGetAllByRecommendProjectListAction = (isSuccess: boolean, item: Project[]): ICallbackGetAllByRecommendProjectListAction => {
        return {
            type: CustomerTutorialActionType.CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST,
            isSuccess,
            item,
        };
    };
}

export const createCustomerTutorialActionCreator = (): ICustomerTutorialActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/customer_tutorial_action.ts